import createStore from '@/store'
import createRouter from '@/router'

export const toISO8601 = (value) => {
  if (value === '00/00/0000' || '') return false
  const __date = new Date(value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'))
  return __date.toISOString()
}

export const formatDate = (date) => {
  if (date) {
    const formatedDate = new Date(date)
    const day = formatedDate.getDate().toString()
    const month = (formatedDate.getMonth() + 1).toString()
    const year = formatedDate.getFullYear().toString()
    return `${day.length === 1 ? '0' + day : day}/${month.length === 1 ? '0' + month : month}/${year}`
  } else {
    return ''
  }
}

export const durationToTime = (duration) => {
  const seconds = parseInt((duration / 1000) % 60)
  const minutes = parseInt((duration / (1000 * 60)) % 60)
  const hours = parseInt((duration / (1000 * 60 * 60)) % 24)
  return (
    (hours !== 0 ? `${hours < 10 ? '0' + hours : hours}:` : '') +
    (minutes < 10 ? '0' + minutes : minutes) +
    ':' +
    (seconds < 10 ? '0' + seconds : seconds)
  )
}

export const convertTimestampToTimeFormat = (timestamp) => {
  let totalSeconds = Math.floor(timestamp / 1000)

  const hours = Math.floor(totalSeconds / 3600)

  totalSeconds %= 3600
  const minutes = Math.floor(totalSeconds / 60)

  const formattedHours = String(hours).padStart(2, '0')
  const formattedMinutes = String(minutes).padStart(2, '0')

  return `${formattedHours}h${formattedMinutes}`
}

export const formatFilesize = (bytes, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }
  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** dp
  do {
    bytes /= thresh
    ++u
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)
  return bytes.toFixed(dp) + ' ' + units[u]
}

export const contentType = (value) => {
  switch (value) {
    case 'staage:staagedocs':
    case 'staage:backstaage':
      return 'Staagedocs'
    case 'staage:staageclass':
    case 'staage:napratica':
      return 'Staageclass'
    default:
      return 'Staage'
  }
}
export const categoryByGroup = (value) => {
  switch (value) {
    case 'STAAGEDOCS':
    case 'BACKSTAAGE':
      return 'Staagedocs'
    case 'STAAGECLASS':
    case 'NAPRATICA':
      return 'Staageclass'
    default:
      return 'Categoria'
  }
}

export const routeByGroup = (value) => {
  switch (value) {
    case 'STAAGEDOCS':
    case 'BACKSTAAGE':
      return 'app.categories.staagedocs'
    case 'STAAGECLASS':
    case 'NAPRATICA':
      return 'app.categories.staageclass'
    default:
      return 'app'
  }
}

export const userPhotoFormat = (value) => {
  if (!value) return ''
  const buckets = ['assets.staage', 'content.staage']
  return buckets.some((b) => value.includes(b)) ? `//${value}` : value
}

export const imageValidate = (file) => {
  if (/\.jpeg$/.test(file.name) && file.size < 4000000) {
    return true
  }
  if (/\.jpg$/.test(file.name) && file.size < 4000000) {
    return true
  }
  return false
}

export const reduceText = (text, length = 100) => {
  return `${text.slice(0, length)} ${text.length < length ? '' : '...'}`
}

export const identifyCreditCardFlag = (cardNumber) => {
  const _cardNumber = cardNumber.replace(/\D/g, '')
  const cards = {
    elo: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/,
    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/,
    diners: /^3(0[0-5]|[68]\d)\d{11}$/,
    'american-express': /^3[47][0-9]{13}$/,
    mastercard: /^(5[1-5]\d{4}|677189)\d{10}$/,
    aura: /^((?!504175))^((?!5067))(^50[0-9])/,
    visa: /^4\d{12}(\d{3})?$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    cabal: /(60420[1-9]|6042[1-9][0-9]|6043[0-9]{2}|604400)/,
    sorocred: /^627892|^636414/,
    banescard: /^636117/
  }
  for (const flag in cards) {
    if (cards[flag].test(_cardNumber)) {
      return flag
    }
  }
}

export const goToFirstLesson = async (_courseID, isLogged, aditionalParams) => {
  createStore.commit('loader/setIsLoading', true)
  try {
    const course = await createStore.dispatch(
      `${isLogged === true ? 'content/getCourseByID' : 'content/getPublicCourseByID'}`,
      _courseID
    )
    if (course) {
      createStore.commit('content/setCourse', course)
      await createRouter.push({
        name: 'app.watch',
        params: {
          courseId: _courseID,
          lessonId: course.courseModules[0].moduleOrder[0].lessonID
        },
        ...aditionalParams
      })
    } else {
      createStore.commit('loader/setIsLoading', false)
    }
  } catch (err) {
    console.error(err)
    createRouter.push({ name: 'app.home' })
  } finally {
    createStore.commit('loader/setIsLoading', false)
  }
}

export const distanceFromHeader = () => {
  return createStore.getters['informationToast/isShowInformationToast']
    ? window.innerWidth <= 425
      ? '13.8rem'
      : '12rem'
    : '8.8rem'
}

export const themes = [
  {
    // INICIANTE EM GROWTH
    themeID: 'iniciante-em-growth',
    themeTitle: 'Iniciante em Growth',
    themeIndex: 'Iniciante em Growth',
    themeImagePath: 'icon-cientista-do-marketing.svg',
    themeDescription:
      'Conheça os fundamentos do growth marketing e explore técnicas básicas para iniciar no mercado digital. Ideal para quem quer aprender métodos de crescimento sustentável desde o início.'
  },
  {
    themeID: 'cientista-do-marketing',
    themeTitle: 'Cientista do marketing',
    themeIndex: 'Cientista do marketing',
    themeImagePath: 'icon-cientista-do-marketing.svg',
    themeDescription:
      'Torne-se especialista em dados e estratégias de marketing baseadas em análise. Aprenda a usar métricas e testes para direcionar decisões que geram valor ao negócio.'
  },
  {
    // CARTAS DE UM MARQUETEIRO
    themeID: 'cartas-de-um-marqueteiro',
    themeTitle: 'Cartas de um marqueteiro',
    themeIndex: 'Cartas de um marqueteiro',
    themeImagePath: 'icon-negocios-vendas.svg',
    themeDescription:
      'Cartas de uma Marqueteiro é uma série de aulas que traz insights, estratégias e lições práticas sobre Growth Marketing, para ajudar profissionais a melhorar seus resultados e explorar o mercado.'
  },
  {
    themeID: 'design',
    themeTitle: 'Design',
    themeIndex: 'Design',
    themeImagePath: 'icon-trafego-pago.svg',
    themeDescription:
      'Explore as principais técnicas e conceitos para criar visuais atrativos e funcionais. Descubra como o design pode comunicar ideias e causar impacto no público.'
  },
  {
    themeID: 'copywriting',
    themeTitle: 'Copywriting',
    themeIndex: 'Copywriting',
    themeImagePath: 'icon-copywriting.svg',
    themeDescription:
      'Aprenda a desenvolver textos que capturam a atenção e incentivam a ação. Com técnicas de persuasão, você entenderá como criar mensagens que envolvem e geram conversão.'
  },

  {
    themeID: 'social-media',
    themeTitle: 'Social Media',
    themeIndex: 'Social Media',
    themeImagePath: 'icon-redes-sociais.svg',
    themeDescription:
      'Aprenda a criar conteúdo relevante que engaja e expande sua presença nas redes. Explore métodos para conquistar e manter uma audiência leal e conectada com sua marca.'
  },
  {
    themeID: 'gestao-de-trafego',
    themeTitle: 'Gestão de tráfego',
    themeIndex: 'Gestão de tráfego',
    themeImagePath: 'icon-trafego-pago.svg',
    themeDescription:
      'Domine as estratégias de mídia paga e SEO para atrair visitantes qualificados a sites e redes sociais. Aprenda a analisar resultados e otimizar campanhas de tráfego digital.'
  },
  {
    themeID: 'lancamentos',
    themeTitle: 'Lançamentos',
    themeIndex: 'Lançamentos',
    themeImagePath: 'icon-lancamentos.svg',
    themeDescription:
      'Entenda o processo de lançamentos digitais para captar atenção e gerar impacto. Aprenda a estruturar estratégias de marketing, comunicação e vendas voltadas para grandes resultados.'
  },
  {
    themeID: 'ecommerce',
    themeTitle: 'E-commerce',
    themeIndex: 'E-commerce',
    themeImagePath: 'icon-ecommerce.svg',
    themeDescription:
      'Descubra como criar e gerenciar sua loja online, desde o planejamento inicial até as estratégias de venda e marketing. Conheça os passos para construir uma presença digital sólida.'
  },
  {
    themeID: 'vendas',
    themeTitle: 'Vendas',
    themeIndex: 'Vendas',
    themeImagePath: 'icon-negocios-vendas.svg',
    themeDescription:
      'Desenvolva habilidades práticas para vender com mais segurança e conecte-se com o cliente de forma estratégica. Aprenda a construir relações e conduzir negociações com confiança.'
  },
  {
    themeID: 'gestao-e-growth-marketing',
    themeTitle: 'Gestão & Growth Marketing',
    themeIndex: 'Gestão & Growth Marketing',
    themeImagePath: 'icon-redes-sociais.svg',
    themeDescription:
      'Desenvolva competências em gestão e estratégias de crescimento para negócios. Entenda como planejar e liderar ações que impulsionam resultados de forma sustentável.'
  },
  {
    themeID: 'customer-success-e-customer-experience',
    themeTitle: 'Customer Success e Customer Experience',
    themeIndex: 'CS & CX',
    themeImagePath: 'icon-negocios-vendas.svg',
    themeDescription:
      'Saiba como construir relacionamentos duradouros e garantir a satisfação dos clientes. Entenda estratégias para oferecer um atendimento de excelência e fidelizar o público.'
  }
]

export const playerLanguages = {
  pt: {
    Play: 'Reproduzir',
    Pause: 'Pausar',
    Rewind: 'Voltar 10 segundos',
    Forward: 'Avançar 10 segundos',
    Mute: 'Mudo',
    Unmute: 'Desmutar',
    Subtitles: 'Legendas',
    Settings: 'Configurações',
    Fullscreen: 'Entrar em Tela-cheia',
    'Non-Fullscreen': 'Sair da tela-cheia',
    Quality: 'Resolução',
    Speed: 'Velocidade',
    Text: 'Texto',
    Background: 'Fundo',
    'subtitles settings': 'Configurações',
    'subtitles off': 'Desligado',
    White: 'Branco',
    Black: 'Preto',
    Red: 'Vermelho',
    Green: 'Verde',
    Blue: 'Azul',
    Cyan: 'Ciano',
    Yellow: 'Amarelo',
    Window: 'Janela',
    'Font Size': 'Tamanho da fonte',
    'Text Edge Style': 'Estilo da borda',
    'Font Family': 'Fonte',
    Opaque: 'Opaco',
    'Semi-Transparent': 'Translúcido',
    Transparent: 'Transparente',
    Raised: 'Levantado',
    Depressed: 'Caido',
    Uniform: 'Uniforme',
    Dropshadow: 'Sombreado',
    Reset: 'Resetar',
    Done: 'Concluir'
  }
}

export const proceedToCheckoutOptions = ['SUBSCRIPTION_CREATED', 'SUBSCRIPTION_CANCELED', 'SUBSCRIPTION_NOT_RECOGNIZED']

export const proceedToCardUpdateOptions = ['SUBSCRIPTION_PENDING_PAYMENT', 'SUBSCRIPTION_PENDING']

export const proceedToLoginOptions = ['SUBSCRIPTION_ALREADY_ACTIVE', 'SUBSCRIPTION_IS_ON_TRIAL', 'SUBSCRIPTION_TRUSTED']

export const staageJobsFieldsValues = {
  outputs: {
    'ASSISTENTE-VIRTUAL': {
      title: 'Assistente Virtual',
      value: 'ASSISTENTE-VIRTUAL',
      abilities: {
        PESSOAL: { title: 'Pessoal', value: 'PESSOAL' },
        COMERCIAL: { title: 'Comercial', value: 'COMERCIAL' },
        'RECURSOS-HUMANOS': { title: 'Recursos Humanos', value: 'RECURSOS-HUMANOS' },
        FINANCEIRO: { title: 'Financeiro', value: 'FINANCEIRO' }
      }
    },
    SUPORTE: {
      title: 'Suporte',
      value: 'SUPORTE',
      abilities: {
        'ATENDENTE-DE-SUPORTE': { title: 'Atendente de suporte', value: 'ATENDENTE-DE-SUPORTE' },
        LANCAMENTOS: { title: 'Lançamentos', value: 'LANCAMENTOS' },
        'RECUPERACAO-DE-BOLETOS': { title: 'Recuperação de boletos', value: 'RECUPERACAO-DE-BOLETOS' },
        'RECUPERACAO-DE-CLIENTES': { title: 'Recuperação de clientes', value: 'RECUPERACAO-DE-CLIENTES' },
        VENDAS: { title: 'Vendas', value: 'VENDAS' }
      }
    },
    'SOCIAL-MEDIA': {
      title: 'Social Media',
      value: 'SOCIAL-MEDIA',
      abilities: {
        'LINHA-EDITORIAL': { title: 'Linha editorial', value: 'LINHA-EDITORIAL' },
        'BRANDING-PERFIL': { title: 'Branding do Perfil', value: 'BRANDING-PERFIL' },
        'ESTUDO-AUDIENCIA': { title: 'Estudo da audiência', value: 'ESTUDO-AUDIENCIA' },
        'CRONOGRAMA-POSTAGENS': { title: 'Cronograma de postagens', value: 'CRONOGRAMA-POSTAGENS' },
        'BIBLIOTECA-POSTS': { title: 'Biblioteca de posts', value: 'BIBLIOTECA-POSTS' },
        'ANALISE-METRICAS': { title: 'Análise de métricas', value: 'ANALISE-METRICAS' },
        'PLANEJAMENTO-ESTRATEGIA': { title: 'Planejamento e estratégia', value: 'PLANEJAMENTO-ESTRATEGIA' }
      }
    },
    DESIGNER: {
      title: 'Designer',
      value: 'DESIGNER',
      abilities: {
        'WEB-DESIGN': { title: 'Web design', value: 'WEB-DESIGN' },
        'REDES-SOCIAIS': { title: 'Redes Sociais', value: 'REDES-SOCIAIS' },
        LOGOS: { title: 'Logos', value: 'LOGOS' },
        'IDENTIDADE-VISUAL': { title: 'Identidade visual', value: 'IDENTIDADE-VISUAL' },
        EMBALAGENS: { title: 'Embalagens', value: 'EMBALAGENS' },
        'DESIGN-EDITORIAL': { title: 'Design editorial', value: 'DESIGN-EDITORIAL' },
        UX: { title: 'UX', value: 'UX' },
        UI: { title: 'UI', value: 'UI' },
        ILUSTRADOR: { title: 'Ilustrador', value: 'ILUSTRADOR' },
        'DIRECAO-ARTE': { title: 'Direção de arte', value: 'DIRECAO-ARTE' },
        'ENCARTE-PAPELARIA': { title: 'Encarte/Papelaria', value: 'ENCARTE-PAPELARIA' }
      }
    },
    'MOTION-DESIGNER': {
      title: 'Motion Designer',
      value: 'MOTION-DESIGNER',
      abilities: {
        ANIMACAO: { title: 'Animação 2D e 3D', value: 'ANIMACAO' },
        DESIGN: { title: 'Design', value: 'DESIGN' },
        'IDENTIDADE-VISUAL': { title: 'Identidade visual', value: 'IDENTIDADE-VISUAL' },
        EDICAO: { title: 'Edição', value: 'EDICAO' },
        'MOTION-DESIGN': { title: 'Motion design', value: 'MOTION-DESIGN' },
        'COLORIZACAO-SONORIZACAO': { title: 'Colorização e sonorização de vídeos', value: 'COLORIZACAO-SONORIZACAO' },
        'DIRECAO-ARTE': { title: 'Direção de arte', value: 'DIRECAO-ARTE' }
      }
    },
    VIDEOMAKER: {
      title: 'Videomaker',
      value: 'VIDEOMAKER',
      abilities: {
        'EDICAO-ANUNCIOS': { title: 'Edição de anúncios', value: 'EDICAO-ANUNCIOS' },
        'VIDEO-VENDAS': { title: 'Vídeo de vendas', value: 'VIDEO-VENDAS' },
        NUGGETS: { title: 'Nuggets', value: 'NUGGETS' },
        'CAPITACAO-FILMAGEM': { title: 'Captação/Filmagem', value: 'CAPITACAO-FILMAGEM' },
        TRANSMICAO: { title: 'Transmissão ao vivo', value: 'TRANSMICAO' },
        IGTV: { title: 'IGTV', value: 'IGTV' },
        YOUTUBE: { title: 'Youtube', value: 'YOUTUBE' },
        LEGENDAGEM: { title: 'Legendagem', value: 'LEGENDAGEM' },
        'VIDEO-LANCAMENTO': { title: 'Vídeo de lançamento', value: 'VIDEO-LANCAMENTO' }
      }
    },
    EDITOR: {
      title: 'Editor',
      value: 'EDITOR',
      abilities: {
        'EDICAO-VIDEOS': { title: 'Edição de vídeos', value: 'EDICAO-VIDEOS' },
        'COLORIZACAO-SONORIZACAO': { title: 'Colorização e sonorização de vídeos', value: 'COLORIZACAO-SONORIZACAO' },
        'EFEITOS-VISUAIS': { title: 'Efeitos visuais', value: 'EFEITOS-VISUAIS' },
        YOUTUBE: { title: 'Youtube', value: 'YOUTUBE' },
        IGTV: { title: 'IGTV', value: 'IGTV' },
        LEGENDAGEM: { title: 'Legendagem', value: 'LEGENDAGEM' },
        'ADOBE-PREMIERE': { title: 'Adobe Premiere', value: 'ADOBE-PREMIERE' },
        'ADOBE-AFTER': { title: 'Adobe After Effects', value: 'ADOBE-AFTER' },
        ROTEIRIZACAO: { title: 'Roteirização', value: 'ROTEIRIZACAO' }
      }
    },
    'SEO-MARKETER': {
      title: 'SEO Marketer',
      value: 'SEO-MARKETER',
      abilities: {
        'SEO-ON': { title: 'SEO On-Page', value: 'SEO-ON' },
        'SEO-OFF': { title: 'SEO Off-Page', value: 'SEO-OFF' },
        'CRIACAO-CONTEUDO': { title: 'Criação de conteúdo', value: 'CRIACAO-CONTEUDO' },
        'ANALISE-DADOS': { title: 'Análise de dados', value: 'ANALISE-DADOS' },
        CONHECIMENTO: { title: 'Conhecimento dos principais buscadores', value: 'CONHECIMENTO' },
        PESQUISA: { title: 'Pesquisa de palavras-chave', value: 'PESQUISA' },
        GERENCIAMENTO: { title: 'Gerenciamento de conteúdo', value: 'GERENCIAMENTO' },
        OTIMIZACAO: { title: 'Otimização de conteúdo', value: 'OTIMIZACAO' }
      }
    },
    'BRAND-MANAGER': {
      title: 'Brand Manager',
      value: 'BRAND-MANAGER',
      abilities: {
        'BRANDING-POSICIONAMENTO': { title: 'Branding e posicionamento', value: 'BRANDING-POSICIONAMENTO' },
        'GERENCIAMENTO-MARCA': { title: 'Gerenciamento de marca', value: 'GERENCIAMENTO-MARCA' },
        'PLANEJAMENTO-ESTRATEGIA': { title: 'Planejamento e estratégia', value: 'PLANEJAMENTO-ESTRATEGIA' },
        'ANALISE-DADOS': { title: 'Análise de dados', value: 'ANALISE-DADOS' },
        'PESQUISA-MERCADO': { title: 'Pesquisas de mercado', value: 'PESQUISA-MERCADO' },
        'GESTAO-PESSOAS': { title: 'Gestão de pessoas', value: 'GESTAO-PESSOAS' }
      }
    },
    'CONTENT-MANAGER': {
      title: 'Content Manager',
      value: 'CONTENT-MANAGER',
      abilities: {
        SEO: { title: 'SEO', value: 'SEO' },
        'PRODUCAO-CONTEUDO': { title: 'Produção de conteúdo', value: 'PRODUCAO-CONTEUDO' },
        'GESTAO-PESSOAS': { title: 'Gestão de pessoas', value: 'GESTAO-PESSOAS' },
        'PLANEJAMENTO-ESTRATEGIA': { title: 'Planejamento e estratégia', value: 'PLANEJAMENTO-ESTRATEGIA' },
        BLOG: { title: 'Blog', value: 'BLOG' },
        'REDES-SOCIAIS': { title: 'Redes sociais', value: 'REDES-SOCIAIS' },
        LEDS: { title: 'Atração de leads', value: 'LEDS' },
        CALENDARIO: { title: 'Calendário editorial', value: 'CALENDARIO' },
        'MKT-CONTEUDO': { title: 'Calendário editorial', value: 'MKT-CONTEUDO' }
      }
    },
    'GROWTH-MARKETER': {
      title: 'Growth Marketer',
      value: 'GROWTH-MARKETER',
      abilities: {
        'ANALISE-DADOS': { title: 'Análise de dados', value: 'ANALISE-DADOS' },
        OTIMIZACAO: { title: 'Otimização de conversão', value: 'OTIMIZACAO' },
        FUNIL: { title: 'Funil de marketing', value: 'FUNIL' },
        'TRAFEGO-PAGO': { title: 'Tráfego pago', value: 'TRAFEGO-PAGO' },
        'TRAFEGO-ORGANICO': { title: 'Tráfego orgânico', value: 'TRAFEGO-ORGANICO' },
        VENDAS: { title: 'Vendas', value: 'VENDAS' },
        'PLANEJAMENTO-ESTRATEGIA': { title: 'Planejamento e estratégia', value: 'PLANEJAMENTO-ESTRATEGIA' },
        PESQUISA: { title: 'Pesquisa', value: 'PESQUISA' },
        BRANDING: { title: 'Branding', value: 'BRANDING' },
        'PSICOLOGIA-COMPORTAMENTAL': { title: 'Psicologia comportamental', value: 'PSICOLOGIA-COMPORTAMENTAL' },
        STORYTELLING: { title: 'Storytelling', value: 'STORYTELLING' }
      }
    },
    COPYWRITER: {
      title: 'Copywriter',
      value: 'COPYWRITER',
      abilities: {
        'PAGINA-VENDAS': { title: 'Página de vendas', value: 'PAGINA-VENDAS' },
        'VIDEO-VENDAS': { title: 'Vídeo de vendas', value: 'VIDEO-VENDAS' },
        ANUNCIOS: { title: 'Anúncios', value: 'ANUNCIOS' },
        'PAGINA-CAPTURA': { title: 'Página de captura', value: 'PAGINA-CAPTURA' },
        'ROTEIRO-VIDEO': { title: 'Roteiro de vídeo', value: 'ROTEIRO-VIDEO' },
        'CRIACAO-PROMOCOES': { title: 'Criação de oferta e promoções', value: 'CRIACAO-PROMOCOES' },
        'NOME-DESCRICAO': { title: 'Nome/descrição do produto', value: 'NOME-DESCRICAO' },
        FUNIL: { title: 'Funil de e-mail', value: 'FUNIL' },
        'PRODUCAO-CONTEUDO': { title: 'Produção de conteúdo', value: 'PRODUCAO-CONTEUDO' }
      }
    },
    TRADUTOR: {
      title: 'Tradutor',
      value: 'TRADUTOR',
      abilities: {
        TEXTOS: { title: 'Textos', value: 'TEXTOS' },
        LIVROS: { title: 'Livros', value: 'LIVROS' },
        EBOOK: { title: 'E-book', value: 'EBOOK' },
        LEGENDA: { title: 'Legenda', value: 'LEGENDA' },
        TRANSCRICAO: { title: 'Transcrição', value: 'TRANSCRICAO' },
        DOCUMENTOS: { title: 'Documentos', value: 'DOCUMENTOS' },
        INTERPRETE: { title: 'Intérprete', value: 'INTERPRETE' }
      }
    },
    REDATOR: {
      title: 'Redator',
      value: 'REDATOR',
      abilities: {
        TRANSCRICAO: { title: 'Transcrição', value: 'TRANSCRICAO' },
        'REDES-SOCIAIS': { title: 'Redes sociais', value: 'REDES-SOCIAIS' },
        'SITES-BLOG': { title: 'Sites/Blogs', value: 'SITES-BLOG' },
        LEGENDAS: { title: 'Legendas', value: 'LEGENDAS' },
        'GHOST-WRITER': { title: 'Ghost Writer', value: 'GHOST-WRITER' }
      }
    },
    'GESTOR-TRAFEGO': {
      title: 'Gestor de Tráfego',
      value: 'GESTOR-TRAFEGO',
      abilities: {
        'TRAFEGO-LOCAL': { title: 'Tráfego local', value: 'TRAFEGO-LOCAL' },
        'CRESCIMENTO-PERFIL': { title: 'Crescimento de perfil', value: 'CRESCIMENTO-PERFIL' },
        'TRAFEGO-PAGO': { title: 'Tráfego pago', value: 'TRAFEGO-PAGO' },
        'ANALISE-METRICAS': { title: 'Análise de métricas', value: 'ANALISE-METRICAS' },
        'GOOGLE-ADS': { title: 'Google Ads', value: 'GOOGLE-ADS' },
        'FACEBOOK-ADS': { title: 'Facebook Ads', value: 'FACEBOOK-ADS' },
        'GOOGLE-ANALYTICS': { title: 'Google Analytics', value: 'GOOGLE-ANALYTICS' }
      }
    },
    'ANALISE-METRICAS': {
      title: 'Analista de Métricas',
      value: 'ANALISE-METRICAS',
      abilities: {
        METRICAS: { title: 'Metricas', value: 'METRICAS' },
        SEO: { title: 'SEO', value: 'SEO' },
        'WEB-ANALYTICS': { title: 'Web Analytics', value: 'WEB-ANALYTICS' },
        'GOOGLE-ANALYTICS': { title: 'Google Analytics', value: 'GOOGLE-ANALYTICS' },
        RELATORIOS: { title: 'Elaboração de relatórios de dados', value: 'RELATORIOS' },
        KPIS: { title: 'KPIS', value: 'KPIS' }
      }
    },
    VENDEDOR: {
      title: 'Vendedor',
      value: 'VENDEDOR',
      abilities: {
        'PSICOLOGIA-COMPORTAMENTAL': { title: 'Psicologia comportamental', value: 'PSICOLOGIA-COMPORTAMENTAL' },
        ESCUTA: { title: 'Escuta ativa', value: 'ESCUTA' },
        'SOCIAL-SELLING': { title: 'Social selling', value: 'SOCIAL-SELLING' },
        PROPSPECCAO: { title: 'Prospecção', value: 'PROPSPECCAO' },
        NEGOCIACAO: { title: 'Negociação', value: 'NEGOCIACAO' },
        'POS-VENDAS': { title: 'Pós-venda', value: 'POS-VENDAS' },
        OBJECOES: { title: 'Objeções', value: 'OBJECOES' }
      }
    },
    ESPECIALISTA: {
      title: 'Especialista',
      value: 'ESPECIALISTA',
      abilities: {
        'PRODUCAO-CONTEUDO': { title: 'Produção de conteúdo', value: 'PRODUCAO-CONTEUDO' },
        'MKT-INFLUENCIA': { title: 'Marketing de influência', value: 'MKT-INFLUENCIA' },
        'ANALISE-DADOS': { title: 'Análise de dados', value: 'ANALISE-DADOS' },
        'REDES-SOCIAIS': { title: 'Redes sociais', value: 'REDES-SOCIAIS' }
      }
    },
    'CRIADOR-CONTEUDO': {
      title: 'Criador de Conteúdo',
      value: 'CRIADOR-CONTEUDO',
      abilities: {
        'MKT-CONTEUDO': { title: 'Marketing de conteúdo', value: 'MKT-CONTEUDO' },
        'MKT-INFLUENCIA': { title: 'Marketing de influência', value: 'MKT-INFLUENCIA' },
        'PRODUCAO-CONTEUDO': { title: 'Produção de conteúdo', value: 'PRODUCAO-CONTEUDO' },
        'REDES-SOCIAIS': { title: 'Redes sociais', value: 'REDES-SOCIAIS' },
        YOUTUBE: { title: 'Youtube', value: 'YOUTUBE' }
      }
    },
    'CO-PRODUTOR': {
      title: 'Co-Produtor',
      value: 'CO-PRODUTOR',
      abilities: {
        'LANCAMENTOS-DIGITAIS': { title: 'Lançamentos Digitais', value: 'LANCAMENTOS-DIGITAIS' },
        'PRODUTOS-FISICOS': { title: 'Produtos Fisicos', value: 'PRODUTOS-FISICOS' },
        'PRODUTOS-DIGITAIS': { title: 'Produtos Digitais', value: 'PRODUTOS-DIGITAIS' },
        VENDAS: { title: 'Vendas', value: 'VENDAS' },
        TRAFEGO: { title: 'Tráfego', value: 'TRAFEGO' }
      }
    },
    LANCADOR: {
      title: 'Lançador',
      value: 'LANCADOR',
      abilities: {
        'LANCAMENTOS-DIGITAIS': { title: 'Lançamentos Digitais', value: 'LANCAMENTOS-DIGITAIS' },
        'PRODUTOS-FISICOS': { title: 'Produtos Fisicos', value: 'PRODUTOS-FISICOS' },
        'PRODUTOS-DIGITAIS': { title: 'Produtos Digitais', value: 'PRODUTOS-DIGITAIS' },
        INFOPRODUTOS: { title: 'Infoprodutos', value: 'INFOPRODUTOS' },
        TRAFEGO: { title: 'Tráfego', value: 'TRAFEGO' },
        ANTECIPACAO: { title: 'Antecipação', value: 'ANTECIPACAO' },
        'NOCOES-COPYWRITING': { title: 'Noções de copywriting', value: 'NOCOES-COPYWRITING' }
      }
    }
  },
  userSocial: ['Facebook', 'Linkedin', 'Instagram', 'Youtube', 'Dribbble', 'Github']
}
export const toggleAccordion = (cardClass, cardId) => {
  const accordionList = document.querySelectorAll(cardClass)
  const accordion = document.getElementById(cardId)

  accordionList.forEach((item) => {
    if (item.id !== cardId) {
      item.classList.remove('active')
    }
  })

  accordion.classList.contains('active') ? accordion.classList.remove('active') : accordion.classList.add('active')
}

export const questionsCardUpdate = [
  {
    question: 'O número do meu cartão consta como inválido, o que devo fazer?',
    answer: `Verifique se todos os dados do seu cartão de crédito (Nome, Número, Válidade CVV) e em seguida tente
    novamente.`
  },
  {
    question: 'Minha transação não foi aprovada pelo banco, o que devo fazer?',
    answer: 'Entre em contato com o banco responsável pelo seu cartão e questione o motivo da recusa.'
  },
  {
    question: 'Meu cartão está bloqueado para transação online, o que devo fazer?',
    answer: `Contate o banco responsável pelo seu cartão e solicite desbloqueio para compras online ou solicite um cartão
    exclusivo para operações como essa, caso tenha essa opção.`
  },
  {
    question: 'Meu cartão não tem saldo suficiente, o que devo fazer?',
    answer: `Verifique no internet banking do seu banco se o limite do cartão utilizado já foi atingido. Se sim,
    tente utilizar outro cartão de crédito para prosseguir com a atualização.`
  },
  {
    question: 'Como entrar em contato com o suporte da Staage?',
    answer: 'Para entrar em contato com o nosso suporte, envie um e-mail com a sua dúvida para suporte@staage.com.'
  }
]

export const faqQuestios = {
  questionsContent: [
    {
      accordionID: 0,
      isAccordionOpen: false,
      accordionTitle: 'O que é a Staage?',
      accordionBody:
        'A Staage é uma plataforma que ensina Marketing Digital com especialistas do mercado, dá acesso aos bastidores de lançamentos milionários, gera certificados de conclusão para alguns cursos e possibilita a divulgação do trabalho dos seus alunos para o mercado.'
    },
    {
      accordionID: 1,
      isAccordionOpen: false,
      accordionTitle: 'Por onde e por quanto tempo tenho acesso ao conteúdo?',
      accordionBody:
        'Você pode acessar todo o conteúdo disponível através do nosso aplicativo para celular, aplicativo para TV LG e através do computador por 12 meses após a confirmação da assinatura. '
    },
    {
      accordionID: 2,
      isAccordionOpen: false,
      accordionTitle: 'Vai ter conteúdo novo e exclusivo para assinantes?',
      accordionBody: 'Sim, pretendemos lançar mais cursos exclusivos para assinantes.'
    }
  ],
  questionsSuport: [
    {
      accordionID: 0,
      isAccordionOpen: false,
      accordionTitle: 'Qual o prazo de garantia da Staage? ',
      accordionBody:
        'Na Staage temos o compromisso com nossos assinantes. Dessa forma, oferecemos 7 dias corridos de garantia, a partir da data de pagamento da assinatura, para a desistência e devolução integral do valor pago pelo assinante. '
    },
    {
      accordionID: 1,
      isAccordionOpen: false,
      accordionTitle: 'Tem a opção de conta familiar?',
      accordionBody:
        'O acesso a plataforma é individual, ou seja, não é possível compartilhar seu login com outras pessoas. Por isso, certifique-se de que está deslogado das demais máquinas, pois o acesso é único.'
    },
    {
      accordionID: 2,
      isAccordionOpen: false,
      accordionTitle: 'Como funciona a renovação da assinatura?',
      accordionBody:
        'A renovação é automática, e ocorre após 12 meses da confirmação do primeiro pagamento (exceto casos promocionais).'
    },
    {
      accordionID: 3,
      isAccordionOpen: false,
      accordionTitle: 'Como saber quando meu plano atual vai terminar? ',
      accordionBody:
        'Você pode consultar o seu período válido atual através do menu: Minha conta > Conta > Próxima renovação '
    }
  ],
  questionsPayment: [
    {
      accordionID: 0,
      isAccordionOpen: false,
      accordionTitle: 'Quais são as possíveis formas de pagamento? ',
      accordionBody:
        'A única forma de pagamento possível é cartão de crédito. A assinatura da plataforma é anual, no valor de R$478.80, que pode ser parcelado no cartão de crédito em até 12x sem juros! '
    },
    {
      accordionID: 1,
      isAccordionOpen: false,
      accordionTitle: 'Posso pagar com um cartão internacional? ',
      accordionBody:
        'Sim, a plataforma permite que você realize o pagamento de sua assinatura em até 12x sem juros. Mas fique atento porque, a maioria dos cartões internacionais não permitem parcelamento. Nesse caso, para concretizar sua assinatura, é necessário que a forma de pagamento selecionada seja à vista (1 parcela). '
    },
    {
      accordionID: 2,
      isAccordionOpen: false,
      accordionTitle: 'Qual o prazo para o estorno? ',
      accordionBody:
        'O processo de reembolso adotado varia entre as operadoras. Desta forma, indicamos que em caso de dúvidas sobre o processo e prazos, consulte o SAC de seu cartão. '
    },
    {
      accordionID: 3,
      isAccordionOpen: false,
      accordionTitle: 'Qual limite preciso ter no meu cartão para realizar a assinatura? ',
      accordionBody:
        'Apesar da assinatura poder ser parcelada em até 12 vezes, sem juros, é necessário que o valor total esteja disponível em seu cartão de crédito. Mensalmente será cobrado somente o valor da parcela escolhida, então não se preocupe caso receba um SMS de sua operadora, informado uma compra com o valor total! Esse é apenas o valor comprometido em sua fatura. '
    }
  ]
}
